const animItems = [
    // Главная
    {
        selector: '.block_default--header,.block_default--foot',
        targets: [
            {
                selector: 'h1,h2,h3,h4,h5,p,ul,ol,button',
                delayBase: .1,
                delayStep: .1,
                anim: 'animate__fadeIn'
            }
        ],
        once: true
    },
    {
        selector: '.block_steps--slider,.block_how_to .block_text .row > *',
        once: true
    },
    {
        selector: '.block_get_loan',
        targets: [
            {
                selector: '.wrapper > *',
                delayBase: .1,
                delayStep: .2,
                anim: 'animate__fadeIn'
            }
        ],
        once: true
    }
];

export default animItems;